import authDictionary from "./authDictionary";
import notificationDictionary from "./notificationDictionary";
import postsDictionary from "./postsDictionary";
import userProfileDictionary from "./userProfileDictionary";
import documentDictionary from "./documentDictionary";
import eligibilityCheckDictionary from "./eligibilityCheckDictionary";
import applicantDetailsDictionary from "./applicantDetailsDictionary";
import applicationDetailsDictionary from "./applicationDetailsDictionary";
import chatDictionary from "./chatDictionary";

const dictionary = {
  auth: authDictionary,
  posts: postsDictionary,
  notifications: notificationDictionary,
  profile: userProfileDictionary,
  document: documentDictionary,
  eligibilityCheck: eligibilityCheckDictionary,
  applicantDetails: applicantDetailsDictionary,
  applicationDetails: applicationDetailsDictionary,
  chat: chatDictionary,
};

export default dictionary;
